













































































































import { Component, Prop } from 'vue-property-decorator';
import Avatar from '@/components/common/Avatar.vue';
import PolicyCustomerShort from '@/components/common/PolicyCustomerShort.vue';
import PolicyProductShort from '@/components/common/PolicyProductShort.vue';
import { ITask, TaskPriority, TaskStatus } from 'admiral-core';
import { mixins } from 'vue-class-component';
import { BaseMixin } from '@/mixins/BaseMixin';
import { FormatMixin } from '@/mixins/FormatMixin';
import dayjs from 'dayjs';
import TaskPriorityMenu from '@/components/tasks/TaskPriorityMenu.vue';
import TaskDueDatePopover from '@/components/tasks/TaskDueDatePopover.vue';
import { TaskApi } from '@/services/TaskApi';

@Component({
  components: {
    Avatar,
    TaskDueDatePopover,
    TaskPriorityMenu,
    PolicyCustomerShort,
    PolicyProductShort,
  },
})
export default class TaskKanbanItem extends mixins(BaseMixin, FormatMixin) {
  @Prop({ type: Object, required: true })
  task!: ITask;

  get taskTags() {
    return this.task.tags || [];
  }

  /** Supports full `files` relation or optional `filesCount` from lean payloads. */
  get filesIndicatorCount(): number {
    const n = this.task.filesCount;
    if (typeof n === 'number') return n;
    return this.task.files?.length ?? 0;
  }

  /** Supports full `comments` relation or optional `commentsCount` from lean payloads. */
  get commentsIndicatorCount(): number {
    const n = this.task.commentsCount;
    if (typeof n === 'number') return n;
    return this.task.comments?.length ?? 0;
  }

  get tagsIndicatorCount(): number {
    const n = this.task.tagsCount;
    if (typeof n === 'number') return n;
    return this.task.tags?.length ?? 0;
  }

  get taskPolicy() {
    const policies = this.task.policies || [];
    if (policies.length > 0) return policies[0];
    const steps = this.task.steps || [];
    const stepWithPolicy = steps.find((s: any) => s.policy);
    return stepWithPolicy?.policy ?? null;
  }

  tagClass(tagIndex: number) {
    return this.tagClasses[tagIndex % this.tagClasses.length];
  }

  get showHeader() {
    return this.isOverdue;
  }

  get isOverdue() {
    if (!this.task.dueAt) return false;

    const activeStatuses = [TaskStatus.TODO, TaskStatus.IN_PROGRESS, TaskStatus.IN_WAITING];

    if (!activeStatuses.includes(this.task.status)) return false;

    return dayjs(this.task.dueAt).isBefore(dayjs(), 'day');
  }

  get dueDateClass(): Record<string, boolean> {
    if (!this.task.dueAt) return {};
    const due = dayjs(this.task.dueAt);
    const today = dayjs().startOf('day');
    const weekEnd = dayjs().endOf('week');
    if (due.isBefore(today, 'day')) return { 'text-danger': true };
    if (due.isSame(today, 'day')) return { 'text-dark font-weight-bold': true };
    if (!due.isAfter(weekEnd)) return { 'text-dark': true };
    return {};
  }

  formatDate(date: Date | string | undefined) {
    if (!date) return '';
    const d = dayjs(date);
    return d.year() === dayjs().year() ? d.format('DD.MM') : d.format('DD.MM.YYYY');
  }

  formatDueDate(date: Date | string | undefined) {
    if (!date) return '';
    const due = dayjs(date);
    if (due.isSame(dayjs(), 'day')) return 'Heute';
    return due.year() === dayjs().year() ? due.format('DD.MM') : due.format('DD.MM.YYYY');
  }

  async onStatusChange(newStatus: TaskStatus) {
    try {
      await TaskApi.updateStatus(this.task.id, this.task, newStatus);
      this.$set(this.task, 'status', newStatus);
      this.$emit('status-changed');
    } catch (e) {
      this.$toastr.e('Status konnte nicht geändert werden.');
    }
  }

  async onPriorityChange(newPriority: TaskPriority) {
    try {
      await TaskApi.updatePriority(this.task.id, this.task, newPriority);
      this.$set(this.task, 'priority', newPriority);
      this.$emit('priority-changed');
    } catch (e) {
      this.$toastr.e('Priorität konnte nicht geändert werden.');
    }
  }
}
